import { AppState } from './app.service'
import { Injectable } from '@angular/core'
import { MESSAGES } from './locale/messages'

const PLACEHOLDER = /%\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g

@Injectable()
export class I18n {
  constructor(private appState: AppState) {
  }

  t(value: any, args?: any): any {
    // const lang = this.appState.get('language') || 'en'
    const rawLang = this.appState.get('language') || 'en'
    const lang = rawLang
    // ?.substr(0, 2)?.toLowerCase()

    if (lang != 'en' && MESSAGES[lang] && MESSAGES[lang][value]) {
      return this.interpolate(MESSAGES[lang][value], args)
    } else {
      return this.interpolate(value, args)
    }
  }

  tForPath(key: string, path: any, args?: any): string {
    const lang = path?.language || this.appState.get('language') || 'en'
    // ?.substr(0, 2)?.toLowerCase();
    const messages = MESSAGES as Record<string, Record<string, string>>;
    if (lang && lang !== 'en' && messages[lang]?.[key]) {
      return this.interpolate(messages[lang][key], args);
    }
    return this.interpolate(key, args);
  }

  // Values are substituted after the catalog lookup, so the English source stays
  // the key and a translation is free to move the placeholder wherever that
  // language needs it. Callers that pass no args are unaffected.
  private interpolate(text: any, args?: any): any {
    if (!args || typeof text !== 'string') { return text }

    // An unfilled placeholder is left in place rather than blanked — a missing
    // value should be visible, not silently swallow part of the sentence.
    return text.replace(PLACEHOLDER, (match, key) =>
      args[key] === undefined || args[key] === null ? match : String(args[key])
    )
  }
}
